import GLightbox from 'glightbox';

GLightbox({
	selector: '.glightbox2',
	closeOnOutsideClick: false,
	touchNavigation: false,
	height: false,
});

// when the user clicks on a (anchor) with the #appointment open the bootstrap modal

const appointmentButtons = document.querySelectorAll('a[href="#appointment"]');
appointmentButtons.forEach((button) => {
	button.addEventListener('click', (e) => {
		e.preventDefault();
		$('#contact-popup').modal('show');
	});
});


const offerButtons = document.querySelectorAll('a[href="#offerte"]');
offerButtons.forEach((button) => {
	button.addEventListener('click', (e) => {
		e.preventDefault();
		$('#offer-popup').modal('show');
	});
});
